<template>
  <div
    class="alpha-bank-payment-frame"
    style="color-scheme: light"
  >
    <iframe
      v-if="confirmationUrl"
      :src="confirmationUrl"
      class="alpha-bank-payment-frame__iframe"
      title="Оплата картой — Альфа-Банк"
      allow="payment *; clipboard-write"
      referrerpolicy="origin"
      @load="handleLoad"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * Платёжная страница Альфа-Банка во фрейме (веб-версия сайта).
 *
 * Страница эквайринга отдаётся без `X-Frame-Options` и с `frame-ancestors *`,
 * поэтому её допустимо показывать во фрейме — карточные данные при этом вводятся
 * на домене банка, к нам они не попадают.
 *
 * В мобильном приложении фрейм НЕ используется: там банк требует системный браузер
 * (Chrome Custom Tabs / SFSafariViewController), иначе ломаются 3-D Secure и deeplink
 * в приложение банка. См. docs/ALFABANK_PAYMENT.md.
 */
interface Props {
  confirmationUrl?: string | null
}

interface Emits {
  (e: 'load'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleLoad = () => {
  emit('load')
}
</script>

<style scoped lang="scss">
.alpha-bank-payment-frame {
  @apply w-full;

  &__iframe {
    @apply w-full rounded-lg border border-gray-200 bg-white;
    // Высота задаётся жёстко: фрейм кросс-доменный, измерить контент банка нельзя.
    // Страница банка растягивается под любую выданную высоту и центрирует контент,
    // поэтому 70vh на высоких экранах давало ~700px пустоты под кнопками оплаты.
    // 660px — замер реальной страницы шлюза: экран выбора способа оплаты 623px,
    // форма ввода карты 638px (одинаково на ширине 480 и 640). Что не влезет —
    // проскроллится внутри фрейма.
    // max-h страхует короткие окна, чтобы фрейм не выдавливал подсказки под ним.
    @apply h-[660px] max-h-[calc(100vh-260px)];
    @apply max-md:h-[calc(100vh-190px)] max-md:max-h-none;
  }
}
</style>
